import React from 'react';
import { useSelector } from '@ecommerce/nest-ssr/common';

const Environment: React.FC = () => {
    const env = useSelector((state: { env: string; }) => state.env);

    if (typeof global.window !== 'undefined') {
        global.window.dataLayer.push({
            'event': 'Environment',
            'environment-value': env
        });
    }

    return null;
};

export default Environment;
